import React from "react";

import Logo from "../../../assets/images/logo_thaniacel.png";
import { useCreateThaniacelContext } from "../create/provider/createThaniacel.provider";
import { useCreateNewsThaniacelContext } from "../create/news/provider/createNewsThaniacel.provider";
import { useCreateUsedThaniacelContext } from "../create/used/provider/createUsedThaniacel.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateThaniacelContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsThaniacelContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedThaniacelContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="my-3 -ml-7 w-24 lg:ml-0 lg:w-32">
            <img
              alt="thaniacel_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
